import modalForm from "./modalForm";
import tableTree from "./tableTree";

export default {
  install: (Vue) => {
    Vue.component("modal-form", modalForm);
    Vue.component("table-tree", tableTree);
  },
};
